// Datos estáticos para el perfil de usuario
// Este archivo contiene todas las opciones predefinidas para los campos del usuario

/**
 * Departamentos disponibles en la empresa
 */
export const DEPARTMENTS = [
  { value: 'HSEQ', label: 'HSEQ' },
  { value: 'Logistica', label: 'Logística' },
  { value: 'Financiera', label: 'Financiera' },
  { value: 'Gerencia', label: 'Gerencia' },
  { value: 'Soporte Administrativo', label: 'Soporte Administrativo' },
  { value: 'No aplica', label: 'No aplica' },
];

/**
 * Tipos de sangre disponibles
 */
export const BLOOD_TYPES = [
  { value: 'A+', label: 'A+' },
  { value: 'A-', label: 'A-' },
  { value: 'B+', label: 'B+' },
  { value: 'B-', label: 'B-' },
  { value: 'AB+', label: 'AB+' },
  { value: 'AB-', label: 'AB-' },
  { value: 'O+', label: 'O+' },
  { value: 'O-', label: 'O-' }
];

/**
 * Profesiones/Posiciones de trabajo más comunes
 * Incluye una opción "Otro" para permitir entrada manual
 */
export const JOB_POSITIONS = [
  // Administrativas
  { value: 'Administrador', label: 'Administrador' },
  { value: 'Asistente Administrativo', label: 'Asistente Administrativo' },
  { value: 'Secretaria', label: 'Secretaria' },
  { value: 'Recepcionista', label: 'Recepcionista' },
  
  // Gerenciales
  { value: 'Gerente General', label: 'Gerente General' },
  { value: 'Gerente de Operaciones', label: 'Gerente de Operaciones' },
  { value: 'Gerente de HSEQ', label: 'Gerente de HSEQ' },
  { value: 'Gerente Financiero', label: 'Gerente Financiero' },
  { value: 'Gerente de Logística', label: 'Gerente de Logística' },
  
  // Operacionales
  { value: 'Conductor', label: 'Conductor' },
  { value: 'Operador de Vehículo', label: 'Operador de Vehículo' },
  { value: 'Auxiliar de Operaciones', label: 'Auxiliar de Operaciones' },
  { value: 'Mecánico', label: 'Mecánico' },
  { value: 'Auxiliar de Mecánica', label: 'Auxiliar de Mecánica' },
  
  // HSEQ y Seguridad
  { value: 'Coordinador HSEQ', label: 'Coordinador HSEQ' },
  { value: 'Especialista en Seguridad', label: 'Especialista en Seguridad' },
  { value: 'Inspector de Seguridad', label: 'Inspector de Seguridad' },
  { value: 'Auditor HSEQ', label: 'Auditor HSEQ' },
  
  // Logística
  { value: 'Coordinador de Logística', label: 'Coordinador de Logística' },
  { value: 'Planificador de Rutas', label: 'Planificador de Rutas' },
  { value: 'Despachador', label: 'Despachador' },
  { value: 'Auxiliar de Logística', label: 'Auxiliar de Logística' },
  
  // Financieras
  { value: 'Contador', label: 'Contador' },
  { value: 'Auxiliar Contable', label: 'Auxiliar Contable' },
  { value: 'Analista Financiero', label: 'Analista Financiero' },
  { value: 'Tesorero', label: 'Tesorero' },
  
  // Recursos Humanos
  { value: 'Coordinador de RRHH', label: 'Coordinador de RRHH' },
  { value: 'Analista de RRHH', label: 'Analista de RRHH' },
  { value: 'Especialista en Nómina', label: 'Especialista en Nómina' },
  
  // Tecnología
  { value: 'Desarrollador', label: 'Desarrollador' },
  { value: 'Soporte Técnico', label: 'Soporte Técnico' },
  { value: 'Administrador de Sistemas', label: 'Administrador de Sistemas' },
  
  // Mantenimiento
  { value: 'Jefe de Taller', label: 'Jefe de Taller' },
  { value: 'Técnico de Mantenimiento', label: 'Técnico de Mantenimiento' },
  { value: 'Soldador', label: 'Soldador' },
  { value: 'Electricista', label: 'Electricista' },
  
  // Comercial
  { value: 'Vendedor', label: 'Vendedor' },
  { value: 'Asesor Comercial', label: 'Asesor Comercial' },
  { value: 'Coordinador Comercial', label: 'Coordinador Comercial' },
  
  // Servicios Generales
  { value: 'Auxiliar de Servicios Generales', label: 'Auxiliar de Servicios Generales' },
  { value: 'Vigilante', label: 'Vigilante' },
  { value: 'Mensajero', label: 'Mensajero' },
  
  // Opción para entrada manual
  { value: 'custom', label: 'Otro (Especificar)' }
];

/**
 * EPS (Entidades Promotoras de Salud) en Colombia
 */
export const EPS_OPTIONS = [
  // EPS Contributivas principales
  { value: 'SURA', label: 'SURA EPS' },
  { value: 'Nueva EPS', label: 'Nueva EPS' },
  { value: 'Sanitas', label: 'Sanitas EPS' },
  { value: 'Famisanar', label: 'Famisanar EPS' },
  { value: 'Compensar', label: 'Compensar EPS' },
  { value: 'Salud Total', label: 'Salud Total EPS' },
  { value: 'Coomeva', label: 'Coomeva EPS' },
  { value: 'Aliansalud', label: 'Aliansalud EPS' },
  { value: 'Comfenalco Valle', label: 'Comfenalco Valle' },
  { value: 'Comfandi', label: 'Comfandi' },
  { value: 'Comfacor', label: 'Comfacor' },
  { value: 'Comfaboy', label: 'Comfaboy' },
  
  // EPS Subsidiadas principales
  { value: 'Capital Salud', label: 'Capital Salud EPS-S' },
  { value: 'Medimas', label: 'Medimas EPS-S' },
  { value: 'Coosalud', label: 'Coosalud EPS-S' },
  { value: 'Mutual SER', label: 'Mutual SER EPS-S' },
  { value: 'Salud Vida', label: 'Salud Vida EPS-S' },
  { value: 'Golden Group', label: 'Golden Group EPS-S' },
  { value: 'Saludcoop', label: 'Saludcoop EPS-S' },
  { value: 'Ecoopsos', label: 'Ecoopsos EPS-S' },
  { value: 'Asmet Salud', label: 'Asmet Salud EPS-S' },
  { value: 'Emssanar', label: 'Emssanar EPS-S' },
  
  // Regímenes especiales
  { value: 'Magisterio', label: 'Fondo Nacional del Magisterio' },
  { value: 'Policía', label: 'Fondo de Prestaciones Sociales de la Policía' },
  { value: 'Fuerzas Militares', label: 'Dirección de Sanidad de las Fuerzas Militares' },
  { value: 'Ecopetrol', label: 'Fondo de Empleados de Ecopetrol' },
  { value: 'Universidad Nacional', label: 'Fondo de Bienestar Social Universidad Nacional' },
  
  // EPS Indígenas
  { value: 'Mallamas', label: 'Mallamas EPS Indígena' },
  { value: 'Pijaos Salud', label: 'Pijaos Salud EPSI' },
  { value: 'Dusakawi', label: 'Dusakawi EPSI' },
  { value: 'Wayuu', label: 'AIC Wayuu EPSI' },
  
  // Otras EPS regionales
  { value: 'Cajacopi', label: 'Cajacopi EPS' },
  { value: 'Capresoca', label: 'Capresoca EPS' },
  { value: 'EPS Convida', label: 'EPS Convida' },
  { value: 'Fundación Salud MIA', label: 'Fundación Salud MIA' },
  { value: 'Saludvida', label: 'Saludvida EPS' },
  
  // Opción para casos especiales
  { value: 'No aplica', label: 'No aplica' },
  { value: 'En trámite', label: 'En trámite de afiliación' },
  { value: 'Otra', label: 'Otra EPS' }
];

/**
 * Función helper para buscar en las opciones
 */
export const searchInOptions = (options, searchTerm) => {
  if (!searchTerm || searchTerm.trim() === '') {
    return options;
  }
  
  const term = searchTerm.toLowerCase().trim();
  return options.filter(option => 
    option.label.toLowerCase().includes(term) ||
    option.value.toLowerCase().includes(term)
  );
};

/**
 * Configuración por defecto para dropdowns con búsqueda
 */
export const DEFAULT_DROPDOWN_CONFIG = {
  itemsPerPage: 10,
  debounceTime: 300,
  enableSearch: true,
  enablePagination: true
};

/**
 * Función para obtener opciones paginadas
 */
export const getPaginatedOptions = (options, page = 1, itemsPerPage = 10, searchTerm = '') => {
  const filteredOptions = searchInOptions(options, searchTerm);
  const totalItems = filteredOptions.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedOptions = filteredOptions.slice(startIndex, endIndex);
  
  return {
    options: paginatedOptions,
    totalItems,
    totalPages,
    currentPage: page,
    hasNextPage: page < totalPages,
    hasPreviousPage: page > 1
  };
};